// import React from 'react';
import './Footer.css';
import logo from '../src/Assets/Logo1.png';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaLinkedin, FaLinkedinIn } from 'react-icons/fa';

function Footer() {
  return (
    <div className="footer-main">
      <div className="footer">
        <div className="footer-logo">
          <img src={logo} alt="Logo" />
        </div>

        <div className="footer-links">
          <div className='page-links'>
            <a href="/"> Services</a>
            <a href="/products">Products</a>
            {/* <a href="">Contact</a> */}
          </div>
        </div>

        <div className="footer-social">
          <a href="https://www.facebook.com/GoldenFiveConsulting" target="_blank" rel="noreferrer"><FaFacebookF /></a>
          <a href="https://x.com/Go5Global" target="_blank" rel="noreferrer"><FaTwitter /></a>
          <a href="https://www.youtube.com/channel/UCkiCw4Gf28vNwohPTqdrFqw/videos" target="_blank" rel="noreferrer"><FaYoutube /></a>
          <a href="https://www.linkedin.com/company/golden-five-consulting/posts/?feedView=all" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
        </div>
      </div>
      <div className="p-box">
        <p>© {new Date().getFullYear()} <span className="name"> Golden Five</span>. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;
